import React, { useState, useEffect } from "react";
import {
  Image,
  Dimensions,
  Text,
  TouchableOpacity,
  View,
  Platform,
  ScrollView,
  StyleSheet,
  Alert,
  ActivityIndicator,
} from "react-native";
import _, { identity } from "lodash";
import { connect } from "react-redux";
import PatientAvatarWithDetail from "../components/PatientAvatarWithDetail";
import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";
import AutoHeightImage from "react-native-auto-height-image";
import Modal from "react-native-modal";
import EnlargeIcon from "../components/EnlargeIcon";
import DownloadIcon from "../components/DownloadIcon";
import { savePrescription } from "../helpers/saveImg";
import { APP_BASE_URL } from "../helpers/storage";
import { API } from "../helpers/axios";

const { width, height } = Dimensions.get("window");

const PrescriptionDetailScreen = (props) => {
  const [activeImage, setActiveImage] = useState("");
  const [prescriptionImg, setPrescriptionImg] = useState("");
  const [adjustedPrescriptionImg, setAdjustedPrescriptionImg] = useState("");
  const [isZoomIn, setIsZoomIn] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [
    isPrescriptionAlreadyRedeemed,
    setIsPrescriptionAlreadyRedeemed,
  ] = useState(false);
  const [isPrescriptionEligible, setIsPrescriptionEligible] = useState(false);
  const [isLoadingPrescriptionData, setIsLoadingPrescriptionData] = useState(
    true
  );
  const [
    isPrescriptionLoadedSuccessfully,
    setIsPrescriptionLoadedSuccessfully,
  ] = useState(false);
  const [isPrescImgSelected, setIsPrescImgSelected] = useState(false);
  const [isAdjustedPrescImgSelected, setIsAdjustedPrescImgSelected] = useState(
    false
  );
  const [activeImageError, setActiveImageError] = useState(false);

  useEffect(() => {
    fetchPrescription();
  }, []);

  useEffect(() => {
    if (prescriptionImg) {
      setIsPrescImgSelected(true);
      Image.getSize(
        prescriptionImg,
        (width, height) => {
          console.log("valid prescriptionImg", { width, height });
          setActiveImage(prescriptionImg);
        },
        (error) => {
          setPrescriptionImg("invalid prescriptionImg", { error });
          setIsLoadingPrescriptionData(false);
          setActiveImageError(true);
        }
      );
    }
  }, [prescriptionImg]);

  useEffect(() => {
    if (adjustedPrescriptionImg) {
      Image.getSize(
        adjustedPrescriptionImg,
        (width, height) => {
          console.log("valid adjustedPrescriptionImg", { width, height });
        },
        (error) => {
          setAdjustedPrescriptionImg("invalid adjustedPrescriptionImg", {
            error,
          });
        }
      );
    }
  }, [adjustedPrescriptionImg]);

  const fetchPrescription = async () => {
    const { prescriptionId } = props.navigation.state.params;

    const {
      data: { data: prescription },
    } = await API.get(`${APP_BASE_URL}/v2/prescription/${prescriptionId}`);

    setPrescriptionImg(prescription.img_url);
    setIsPrescriptionAlreadyRedeemed(
      prescription.order_status !== null ? true : false
    );
    setIsPrescriptionEligible(!!prescription.is_eligible);

    if (prescription.has_prescription_adjustment === 1) {
      setAdjustedPrescriptionImg(prescription.adjusted_img_url);
    }
  };

  const showZoomIn = () => {
    if (activeImage) {
      setIsZoomIn(true);
    } else {
      Alert.alert("Kesalahan", "Invalid Image Url");
    }
  };

  const dismissZoomIn = () => {
    setIsZoomIn(false);
  };

  const onBackButtonPressed = () => {
    props.navigation.navigate("PrescriptionHistory");
  };

  const onRedeemButtonPressed = () => {
    const {
      prescriptionId,
      customerName,
      patientName,
      cardNumber,
      gender,
      pharmacy,
    } = props.navigation.state.params;

    if (isPrescriptionAlreadyRedeemed) {
      Alert.alert("Kesalahan", "Resep sudah ditebus");
    } else if (!isPrescriptionEligible) {
      Alert.alert(
        "Resep tidak dapat ditebus",
        "Mohon maaf, resep hanya dapat ditebus maksimal 7 hari setelah konsultasi"
      );
    } else {
      props.navigation.navigate("OrderMedicine", {
        prescriptionId,
        customerName, // this is used for avatar display
        patientName, // this is patient name used for prescription
        cardNumber,
        gender,
        pharmacy,
      });
    }
  };

  const changeImage = (imageUrl, buttonSelected) => {
    if (buttonSelected === "adjustedButton") {
      setIsAdjustedPrescImgSelected(true);
      setIsPrescImgSelected(false);
    } else {
      setIsAdjustedPrescImgSelected(false);
      setIsPrescImgSelected(true);
    }

    if (imageUrl === "invalid image") {
      setActiveImage();
      setActiveImageError(true);
    } else {
      setActiveImage();
      setActiveImageError();
      setActiveImage(imageUrl);
    }
  };

  const onDownloadButtonPressed = () => {
    if (activeImage) {
      setIsDownloading(true)
      savePrescription(activeImage).then((x) => {
        setIsDownloading(false)
      })
    } else {
      Alert.alert("Kesalahan", "Resep tidak dapat diunduh.");
    }
  };

  const onLoadEnd = () => {
    setIsLoadingPrescriptionData(false);
    setIsPrescriptionLoadedSuccessfully(true);
  };

  return (
    <ScrollView style={{ flex: 1 }}>
      <View style={{ backgroundColor: props.themeColors.primary }}>
        <Modal
          isVisible={isZoomIn}
          backdropColor="grey"
          onBackButtonPress={dismissZoomIn}
          onBackdropPress={dismissZoomIn}
          useNativeDriver={true}
        >
          <AutoHeightImage
            alignSelf="center"
            source={{ uri: activeImage }}
            width={width}
          />
        </Modal>
        <View style={styles.header}>
          <PatientAvatarWithDetail
            cardNumber={props.navigation.state.params.cardNumber}
            fullName={props.navigation.state.params.customerName}
            gender={props.navigation.state.params.gender}
          />
          <TouchableOpacity
            style={{ marginStart: 20 }}
            onPress={() => this.scrollRef.scrollTo({ x: 0, y: 500 })}
          ></TouchableOpacity>
        </View>

        <View
          style={{
            backgroundColor: "#FFF",
            borderTopEndRadius:
              Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
            borderTopStartRadius:
              Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
          }}
        >
          <View style={{ paddingTop: 10, alignSelf: "center" }}>
            <Text style={styles.prescriptionTitle}>RESEP OBAT</Text>
          </View>
          <View style={[styles.containerImageFeatures, { marginRight: 20 }]}>
            {adjustedPrescriptionImg ? (
              <View style={styles.containerImageFeatures}>
                <View
                  style={[
                    styles.menu,
                    styles.buttonMenu,
                    { marginRight: 15 },
                    isPrescImgSelected
                      ? { backgroundColor: props.themeColors.primary }
                      : styles.buttonMenuDisable,
                  ]}
                >
                  <TouchableOpacity
                    onPress={() => changeImage(prescriptionImg, "")}
                  >
                    <Text style={[styles.textButton, { fontSize: 12 }]}>
                      RESEP AWAL
                    </Text>
                  </TouchableOpacity>
                </View>
                <View
                  style={[
                    styles.menu,
                    styles.buttonMenu,
                    isAdjustedPrescImgSelected
                      ? { backgroundColor: props.themeColors.primary }
                      : styles.buttonMenuDisable,
                  ]}
                >
                  <TouchableOpacity
                    onPress={() =>
                      changeImage(adjustedPrescriptionImg, "adjustedButton")
                    }
                  >
                    <Text style={[styles.textButton, { fontSize: 12 }]}>
                      RESEP BARU
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            ) : null}

            <TouchableOpacity onPress={showZoomIn}>
              <View style={styles.menu}>
                <EnlargeIcon
                  fill="none"
                  stroke={props.themeColors.primary}
                  strokeWidth="12"
                  style={styles.imageFeature}
                />
              </View>
            </TouchableOpacity>
            <TouchableOpacity onPress={onDownloadButtonPressed}>
              <View style={styles.menu}>
                {isDownloading ? (
                  <ActivityIndicator
                    size="large"
                    color={props.themeColors.primary}
                  />
                ) : (
                  <DownloadIcon
                    fill="none"
                    stroke={props.themeColors.primary}
                    strokeWidth="19"
                    style={styles.imageFeature}
                  />
                )}
              </View>
            </TouchableOpacity>
          </View>
          {isLoadingPrescriptionData ? (
            <View style={{ paddingTop: height * 0.2, alignItems: "center" }}>
              <ActivityIndicator
                size="large"
                color={props.themeColors.primary}
              />
            </View>
          ) : null}
          {activeImage ? (
            <View>
              <View style={styles.containerImage}>
                <AutoHeightImage
                  source={{ uri: activeImage }}
                  width={
                    isAdjustedPrescImgSelected
                      ? Dimensions.get("window").width * 0.9
                      : Dimensions.get("window").width
                  }
                  fadeDuration={1000}
                  onLoadEnd={onLoadEnd}
                />
              </View>
              {isPrescriptionLoadedSuccessfully ? (
                <View>
                  <View style={styles.imageNote}>
                    <Text>Resep hanya bisa ditebus satu kali</Text>
                  </View>

                  <View style={styles.containerListButton}>
                    <TouchableOpacity
                      onPress={onBackButtonPressed}
                      style={{ alignSelf: "center" }}
                    >
                      <View style={styles.containerButton}>
                        <Text style={styles.textButton}>KEMBALI</Text>
                      </View>
                    </TouchableOpacity>

                    <TouchableOpacity
                      onPress={onRedeemButtonPressed}
                      style={{ alignSelf: "center" }}
                    >
                      <View
                        style={[
                          isPrescriptionAlreadyRedeemed ||
                          !isPrescriptionEligible
                            ? styles.redeemButtonDisabled
                            : styles.redeemButtonEnabled,
                        ]}
                      >
                        <Text style={styles.textButton}>TEBUS RESEP</Text>
                      </View>
                    </TouchableOpacity>
                  </View>
                </View>
              ) : null}
            </View>
          ) : null}
          {activeImageError ? (
            <View
              style={{ paddingTop: 10, alignSelf: "center", marginBottom: 30 }}
            >
              <Image
                source={require("../assets/icons/fail.png")}
                style={styles.iconFail}
              />
              <View style={styles.imageNote}>
                <Text>Data resep gagal dimuat</Text>
              </View>
            </View>
          ) : null}
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  header: {
    flexDirection: "row",
    alignItems: "center",
    padding: 20,
  },
  prescriptionTitle: {
    fontSize: 24,
    ...fonts.bold,
    color: "#000",
    width: 250,
    textAlign: "center",
    paddingVertical: 16,
  },
  containerImageFeatures: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginBottom: 10,
  },
  imageFeature: {
    width: 25,
    height: 27,
    marginRight: 20,
  },
  containerImage: {
    marginRight: 30,
    marginLeft: 30,
    alignSelf: "center",
  },
  imageNote: {
    alignSelf: "center",
    marginVertical: 20,
  },
  containerListButton: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  containerButton: {
    borderRadius: 30,
    alignSelf: "flex-start",
    backgroundColor: staticColors.red,
    paddingVertical: 10,
    paddingHorizontal: 35,
    marginLeft: width * 0.1,
  },
  textButton: {
    ...fonts.bold,
    color: "#FFF",
    textAlign: "center",
  },
  redeemButtonEnabled: {
    borderRadius: 30,
    alignSelf: "flex-start",
    backgroundColor: staticColors.forestFern,
    paddingVertical: 10,
    paddingHorizontal: 30,
    marginRight: width * 0.1,
  },
  redeemButtonDisabled: {
    borderRadius: 30,
    alignSelf: "flex-start",
    backgroundColor: staticColors.grey,
    paddingVertical: 10,
    paddingHorizontal: 30,
    marginRight: width * 0.1,
  },
  iconFail: {
    width: 250,
    height: 250,
    alignSelf: "center",
    marginTop: 40,
    marginBottom: 10,
  },
  menu: {
    borderRadius: 30,
    alignSelf: "center",
    paddingVertical: 3,
  },
  buttonMenu: {
    paddingHorizontal: 15,
    marginRight: 10,
    marginTop: 5,
  },
  buttonMenuDisable: {
    backgroundColor: staticColors.grey,
  },
});

export default connect((state) => ({
  themeColors: state.themeColors,
  token: state.token,
}))(PrescriptionDetailScreen);
